import { render, staticRenderFns } from "./KnowledgeHubEdit.vue?vue&type=template&id=11656f10&scoped=true&"
import script from "./KnowledgeHubEdit.vue?vue&type=script&lang=js&"
export * from "./KnowledgeHubEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11656f10",
  null
  
)

export default component.exports